import { render } from "./ShowCounter1.vue?vue&type=template&id=5d00339e"
import script from "./ShowCounter1.vue?vue&type=script&lang=js"
export * from "./ShowCounter1.vue?vue&type=script&lang=js"

import exportComponent from "C:\\files\\vue3_lesson_demo\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__